export default "__VITE_ASSET__1ce5d2b2__"